import React, { CSSProperties } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import { IconButton } from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import "./SchedulingMatrix/controls/styles/MatrixControls.css";
import { useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { navSliceActions } from "../../store/slices/NavSlice";
import InteractionParentInterval from "../../models/interactions/InteractionParentInterval";
import Interval from "../../models/communications/Interval";

interface MatrixIntervalControlsProps {
  interval: Interval;
  parentID: string | number | null;
  interactionParentInterval: InteractionParentInterval | null;
}

const IntervalControls = (props: MatrixIntervalControlsProps) => {
  const rightDrawerOpen = useStoreSelector(
    (state) => state.nav.rightDrawerOpen,
  );
  const dispatch = useStoreDispatch();
  const [communicationsChecked, setCommunicationsChecked] = useState(false);

  function handleOpenEdit() {
    dispatch(
      navSliceActions.openRightDrawer({
        content: props.interval,
        type: "intervals",
      }),
    );
  }

  async function handleOpenEditCommunications(
    event: React.ChangeEvent<HTMLInputElement>,
  ) {
    setCommunicationsChecked(event.target.checked);
    let commSetID: number | null = -1;
    let interactionParentIntervalID = -1;
    if (props.interactionParentInterval) {
      commSetID = props.interactionParentInterval.communication_set_id;
      interactionParentIntervalID = props.interactionParentInterval.id;
    }

    await dispatch(
      navSliceActions.setCurrentParent({
        currentParent: props.parentID,
      }),
    );

    await dispatch(
      navSliceActions.setIntervalID({
        intervalID: props.interval.id,
      }),
    );
    dispatch(
      navSliceActions.openRightDrawer({
        content: commSetID,
        type: "communications",
        resourceID: interactionParentIntervalID,
        resourceName: "interaction_parent_interval",
      }),
    );
    if (props.interval.communication_set_id) {
      setCommunicationsChecked(true);
    } else {
      setCommunicationsChecked(false);
    }
  }

  const [style, setStyle] = useState<CSSProperties>({ display: "none" });
  const [show, setShow] = useState<boolean>(false);

  const displayStyle: CSSProperties = {
    backgroundColor: "#fcfbe6",
    opacity: "1",
    borderRadius: "10px",
    display: "inline-block",
    padding: "0px",
    margin: "0px",
    position: "absolute",
  };

  return (
    <Box
      sx={{ flexGrow: 1 }}
      style={{ padding: "0px", margin: "0px" }}
      onMouseEnter={(e) => {
        if (!show) {
          setStyle(displayStyle);
          setShow(true);
        }
      }}
      onMouseLeave={(e) => {
        if (show) {
          setStyle({ display: "none" });
          setShow(false);
        }
      }}
    >
      <Grid container spacing={2} style={{ textAlign: "center" }}>
        <Grid item xs={12}>
          {props.interval.name}
        </Grid>
        <Grid className={"elementToFadeInAndOut"} item xs={12} style={style}>
          <IconButton onClick={handleOpenEdit}>
            <ModeEditIcon />
          </IconButton>
          <Checkbox
            disabled={rightDrawerOpen}
            onChange={handleOpenEditCommunications}
            size="small"
            icon={<EventBusyIcon />}
            inputProps={{ "aria-label": "controlled" }}
            checkedIcon={<EventAvailableIcon />}
            checked={communicationsChecked}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IntervalControls;
